import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import type { DueDateFilterValue } from "./SuggestedChasableFiltersContext";

const DUE_DATE_OPTIONS: { id: DueDateFilterValue; label: string }[] = [
  { id: "all", label: "All" },
  { id: "overdue", label: "Overdue" },
  { id: "7", label: "Due in next 7 days" },
  { id: "30", label: "Due in next 30 days" },
];

type Props = {
  dueDateFilter: DueDateFilterValue;
  onDueDateFilterChange(dueDateFilter: DueDateFilterValue): void;
};

export function DueDateFilter({ dueDateFilter, onDueDateFilterChange }: Props) {
  const value = DUE_DATE_OPTIONS.find((opt) => opt.id === dueDateFilter) ?? DUE_DATE_OPTIONS[0];

  return (
    <Autocomplete
      size="small"
      options={DUE_DATE_OPTIONS}
      value={value}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, v) => option.id === v.id}
      onChange={(_, newValue) => onDueDateFilterChange(newValue?.id ?? "all")}
      renderInput={(params) => <TextField {...params} label="Due date" />}
      sx={{ minWidth: 200 }}
    />
  );
}
